import createPlugin from './createPlugin';
import Html5VideoHtmlRenderer from './Renderer/Html5VideoHtmlRenderer';
var plugin = createPlugin({
    Renderer: Html5VideoHtmlRenderer,
});
export default plugin;
//# sourceMappingURL=index.js.map